import { Component, OnInit, Input } from '@angular/core';
import { VerticalTabGroupComponent } from '../vertical-tab-group/vertical-tab-group.component';

@Component({
  selector: 'app-vertical-tab',
  templateUrl: './vertical-tab.component.html'
})
export class VerticalTabComponent implements OnInit {

  @Input() 
  public title: string = '';
  
  @Input()
  public hasError: boolean = false;

  @Input()
  public isActive: boolean = false;

  constructor() {
   }

  ngOnInit() {
  }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/components/vertical-tab/vertical-tab.component.ts